module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/vi-1ae3b627580608e32c9947b9a2a87144.svg";